export default "__VITE_ASSET__DYMKm$iF__"